import type { CSSProperties } from 'react';
import { HOME_PARTNER_LOGOS } from '../constants/homePartnerLogos';
import { useI18n } from '../i18n';
import { HorizontalCarousel } from './HorizontalCarousel';
import homeStyles from '../pages/HomePage.module.css';
import styles from './PartnerLogoStrip.module.css';

function partnerLogoImgStyle(imageScale?: number): CSSProperties | undefined {
  if (!imageScale || imageScale === 1) {
    return undefined;
  }
  return { transform: `scale(${imageScale})` };
}

export function PartnerLogoStrip() {
  const { t } = useI18n();
  const title = t('home.partnerLogos');

  return (
    <section className={homeStyles.section} aria-label={title}>
      <div className={homeStyles.sectionHead}>
        <h2 className={homeStyles.sectionTitle}>{title}</h2>
      </div>
      <HorizontalCarousel
        ariaLabel={title}
        prevAriaLabel={t('home.partnerLogosPrev')}
        nextAriaLabel={t('home.partnerLogosNext')}
        contentKey={HOME_PARTNER_LOGOS.map((logo) => logo.id).join(',')}
        scrollClassName={styles.logoCarouselScroll}
      >
        {HOME_PARTNER_LOGOS.map((logo) => (
          <div
            key={logo.id}
            className={styles.logoItem}
            style={logo.circleBackground ? { background: logo.circleBackground } : undefined}
          >
            <img
              src={logo.imageSrc}
              alt={logo.name}
              className={styles.logoImg}
              style={partnerLogoImgStyle(logo.imageScale)}
              loading="lazy"
              decoding="async"
            />
          </div>
        ))}
      </HorizontalCarousel>
    </section>
  );
}
